<section class="left-nav-wrapper bg-grey scroll-container">
  <div class="d-flex">
    <h1 class="page-title me-auto">Payroll Hub</h1>
  </div>
  <div
    *ngIf="isAutoPayrollClient && startData.ActivePayroll?.PayType == payTypes.Manual"
    class="error-text small fw-bold pb-2">
    *You have pending checks that need to be processed to allow auto-payroll to run successfully.
  </div>
  <div *ngIf="startData && clientSetup" class="row row-eq-height container-wrapper">
    <div class="col-lg-6 col-sm-12">
      <run-payroll-tile
        *ngIf="!isAutoPayrollClient || activeAutoPayGrid?.IsAutomaticSkipped; else autoPayrollTile"
        class="h-100"
        [clientCode]="clientCode"
        [clientSetup]="clientSetup"
        [payrollStartData]="startData"
        [prefundWarnings]="prefundWarnings"
        [activeAutoPayGrid]="activeAutoPayGrid">
      </run-payroll-tile>
      <ng-template #autoPayrollTile>
        <lib-run-auto-payroll-tile
          class="h-100"
          [clientCode]="clientCode"
          [clientSetup]="clientSetup"
          [payrollStartData]="startData"
          [activePayroll]="activeAutoPayGrid">
        </lib-run-auto-payroll-tile>
      </ng-template>
    </div>
    <div class="col-lg-6 col-sm-12">
      <manual-payroll-tile
        class="h-100"
        [clientSetup]="clientSetup"
        [clientCode]="clientCode"
        [payrollStartData]="startData">
      </manual-payroll-tile>
    </div>
    <div class="col-lg-6 col-sm-12">
      <lib-off-cycle-payroll-tile
        class="h-100"
        [clientCode]="clientCode"
        [clientSetup]="clientSetup"
        [payrollStartData]="startData"
        [prefundWarnings]="prefundWarnings">
      </lib-off-cycle-payroll-tile>
    </div>
    <div class="col-lg-6 col-sm-12" *ngIf="isCsr">
      <lib-adjustment-payroll-tile
        class="h-100"
        [clientCode]="clientCode"
        [clientSetup]="clientSetup"
        [payrollStartData]="startData">
      </lib-adjustment-payroll-tile>
    </div>
    <div class="col-lg-6 col-sm-12" *ngIf="canAccessGeneralLedgerTile">
      <lib-general-ledger-tile></lib-general-ledger-tile>
    </div>
    <div
      class="col-lg-6 col-sm-12"
      *ngIf="clientSetup.AllowsCheckPrinting || clientSetup.HasCentralChecking">
      <lib-print-checks class="h-100" [clientCode]="clientCode"></lib-print-checks>
    </div>
  </div>
</section>
